import { Button, Modal } from "@/components";
import styles from "./DeleteProfileModal.module.scss";

type DeleteProfileModalProps = {
  isOpen: boolean;
  profileName: string;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
};

export const DeleteProfileModal = ({
  isOpen,
  profileName,
  onClose,
  onConfirm,
  isDeleting,
}: DeleteProfileModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={isDeleting ? () => {} : onClose}>
      <div className={styles["comp"]}>
        <div>
          <div className={styles["comp__heading"]}>Delete profile?</div>
          <p className={styles["comp__description"]}>
            This profile will be removed. Devices using it will lose this assignment.
          </p>
          <div className={styles["comp__fileName"]} title={profileName}>
            „{profileName}”
          </div>
        </div>

        <div className={styles["comp__actions"]}>
          <Button type="button" variant="secondary" onClick={onClose} disabled={isDeleting}>
            Cancel
          </Button>
          <Button type="button" variant="danger" onClick={onConfirm} disabled={isDeleting}>
            {isDeleting ? "Deleting…" : "Delete"}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
